import { useSelector } from 'react-redux';
import type { VoidFunctionComponent } from 'react';

import * as PackageInventoryStore from '../../../../../redux/packageInventory';
import { Details } from '../../../../shared/vulns/Drawer';

/**
 * Container component for the VulnerabilityDrawerDetails
 */
const PackageVulnerabilityDrawerDetails: VoidFunctionComponent = () => {
  const { isLoading } = useSelector(PackageInventoryStore.selectors.getAsyncStatusGetSelectedVuln);
  const selectedVulnDetails = useSelector(PackageInventoryStore.selectors.getSelectedVulnDetails);

  return (
    <Details
      isLoading={isLoading}
      selectedVulnDetails={selectedVulnDetails}
    />
  );
};

export default PackageVulnerabilityDrawerDetails;
